import { render } from "./orderView.vue?vue&type=template&id=582ae39e&scoped=true"
import script from "./orderView.vue?vue&type=script&lang=js"
export * from "./orderView.vue?vue&type=script&lang=js"

import "./orderView.vue?vue&type=style&index=0&id=582ae39e&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582ae39e"]])

export default __exports__